import React from 'react';
import { LiveComponent } from '@amzn/aws-tc-xb-xps';
import { PageHeader } from '../header/PageHeader';
import { Footer } from '../footer/Footer';

/**
 * Header live component
 * Uses local PageHeader directly instead of loading ACINav to avoid ACI Global Nav fallback issue.
 */
export const LiveHeader: React.FC = () => {
    return <PageHeader />;
};

/**
 * Footer live component
 * Uses local Footer directly instead of loading SkillBuilderFooter to avoid fallback issues.
 */
export const LiveFooter: React.FC = () => {
    return <Footer />;
};
